/* istanbul ignore file */
export const SOURCE_QUERY_PARAM = 'source_uri';
export const REDIRECT_QUERY_PARAM = 'redirect_uri';
export const AUTH_EVENT_PARAM = 'authEvent';
export const LOCALE_QUERY_PARAM = 'locale';
export const ISSUER_QUERY_PARAM = 'issuer_params';
export const ERROR_PARAM = 'error';
export const NO_LOGIN_PARAM = 'no_login';
